var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"index-metric-health\">\n<h4>Health</h4>\n<table class=\"table\">\n<thead>\n<tr>\n<th>&nbsp;</th>\n<th></th>\n</tr>\n</thead>\n<tbody>\n<tr>\n<td>Shards</td>\n<td>{{iMHealthCtrl.summary.settings.number_of_shards}} / {{iMHealthCtrl.summary.settings.number_of_replicas}}</td>\n</tr>\n</tbody>\n</table>\n</div>";
var id1="components/index-metric-health/index-metric-health.template.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./ui/src/components/index-metric-health/index-metric-health.template.html
// module id = 872
// module chunks = 0